import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Popover, Button } from 'antd'
import { ArrowDownOutlined } from '@ant-design/icons'
import moment from 'moment'
import ModalD from 'components/ModalD'
import MyIcon from 'components/MyIcon'
import { proxyFetch } from 'utils/fetchData'
import { Link } from 'react-router-dom'
import loadable from 'utils/loadable'
import cls from './index.module.scss'
import { useTranslation } from 'react-i18next';
import { changeLng } from 'reducers/commonSlice'

const ChangeLanguage = loadable(() => import('./ChangeLanguage'))

export default function Top() {
  const remain = useSelector(state => state.shopData)
  const dispatch = useDispatch()
  const { users = {} } = useSelector(state => state.user)
  const { t, i18n } = useTranslation();

  // useEffect(() => {
  //   proxyFetch({
  //     url: '/shop/info',
  //     method: 'GET'
  //   }).then(res => {
  //     dispatch({
  //       type: 'saveUser',
  //       payload: {
  //         ...res.data
  //         // app_key: 'shopify'
  //       }
  //     })
  //   })
  //   aigcRemain()
  // }, [])

  // useEffect(() => {
  //   if (users?.app_key !== 'shopify') {
  //     dispatch(changeLng('zh-CN'))
  //   } else {
  //     dispatch(changeLng('en'))
  //   }
  // }, [users])

  const foramtDate = date => {
    return moment(date).format('YYYY-MM-DD')
  }

  const content = (
    <div>
      <div style={{ fontWeight: 'bold', fontSize: 18 }}>
        {users?.user_nick || users?.shop_name || '--'}
      </div>
      <div>到期时间：{foramtDate(remain?.deadLine)}</div>
      <div>
        <div style={{ padding: 12, background: '#F7F8FA' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start'
            }}
          >
            <span
              style={{
                fontWeight: 'bold',
                fontSize: 18,
                width: 65,
                display: 'inline-block'
              }}
            >
              标准版
            </span>
            <div style={{ marginLeft: 12 }}>
              <Link to={'/others/packages'} state={{ itemKey: 1 }}>
                立即续费
              </Link>
            </div>
          </div>
          <div>剩余积分：{remain.integral}</div>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Link to={'/others/orders'} state={{ itemKey: 2 }}>
          订单管理
        </Link>
        <Link to={'/others/integral'} state={{ itemKey: 3 }}>
          积分纪录
        </Link>
      </div>
    </div>
  )

  const aigcRemain = () => {
    proxyFetch({
      url: '/shop/aigcRemain',
      method: 'GET',
      params: {}
    })
      .then(res => {
        if (res.code == 200 && res?.data) {
          dispatch({
            type: 'setShop',
            payload: res.data
          })
        }
      })
      .catch(err => {
        console.log('err~~', err)
      })
  }

  const createShortcut = () => {
    var blob = new Blob(
      [
        `[InternetShortcut]\r\nURL=https://oauth.taobao.com/authorize?response_type=code&client_id=34615021&redirect_uri=http://aigc.dadaowl.com/topAuth&state=1&view=web`
      ],
      { type: 'text/plain' }
    )
    var url = URL.createObjectURL(blob)

    var link = document.createElement('a')
    link.setAttribute('href', url)
    link.setAttribute('download', '大道AI助手.url')
    link.style.display = 'none'

    document.body.appendChild(link)

    link.click()

    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        minWidth: 600,
        justifyContent: 'flex-end'
      }}
    >
      {/* <Popover content={content} title="" trigger="hover">
        <span>
          <MyIcon
            type="icon-dianpu"
            style={{
              fontSize: 26,
              marginRight: 5,
              position: 'relative',
              top: 4
            }}
          />
          <span>
            {users?.app_key !== 'shopify'
              ? users?.user_nick
              : users?.shop_name}
          </span>
        </span>
      </Popover> */}
      <ChangeLanguage appKey={users?.app_key} />
    </div>
  )
}
